import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { useWishlistId } from '@grandvisionhq/svc-wishlist';
import GET_MY_WISHLIST_ID from '../operations/queries/get-my-wishlist-id.js';

const useGetMyWishlistId = ()=>{
    var ref, ref1;
    const { locale  } = useIntl();
    const { data , loading , error , refetch  } = useQuery(GET_MY_WISHLIST_ID, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    useWishlistId(refetch);
    var ref2;
    return {
        id: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : (ref1 = ref.wishlist) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : undefined,
        loading,
        error: error || null
    };
};

export { useGetMyWishlistId };
//# sourceMappingURL=use-get-my-wishlist-id.js.map
